"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cta;
exports.CtaBtn = CtaBtn;
exports.CtaLink = CtaLink;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Cta = require("./Cta.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Cta(_ref) {
  var children = _ref.children,
      vertical = _ref.vertical;
  return _react.default.createElement("div", {
    className: (0, _Cta.oCta)({
      vertical: vertical
    }).toString()
  }, children);
}

Cta.propTypes = {
  children: _propTypes.default.node,
  vertical: _propTypes.default.bool
};
Cta.defaultProp = {
  children: null,
  vertical: false
};

function CtaBtn(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("div", {
    className: (0, _Cta.oCta)("btn").toString()
  }, children);
}

CtaBtn.propTypes = {
  children: _propTypes.default.node
};
CtaBtn.defaultProp = {
  children: null
};

function CtaLink(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("div", {
    className: (0, _Cta.oCta)("link").toString()
  }, children);
}

CtaLink.propTypes = {
  children: _propTypes.default.node
};
CtaLink.defaultProp = {
  children: null
};